import { Request } from '../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../httpClient/serverApi/types/IResponse';
import { IExplorableItemTypeInfo } from '../../models/resourceInfoParts';
import { ICreatedItem } from '../types/resourceParts';

export interface UpdateServerWelcomeChannelInfoParams {
  welcomeChannelEnabledForServer: boolean;
  welcomeChannelServerFooter: string;
}

export interface IServerWelcomeChannelInfo extends ICreatedItem, IExplorableItemTypeInfo<'site'> {
  welcomeChannelEnabledForServer: boolean;
  welcomeChannelServerFooter: string;
}

export type IUpdateServerWelcomeChannelInfoResult = IResult & IServerWelcomeChannelInfo;

export class UpdateServerWelcomeChannelInfoRequest extends Request<UpdateServerWelcomeChannelInfoParams, IUpdateServerWelcomeChannelInfoResult> {
  constructor(params: UpdateServerWelcomeChannelInfoParams) {
    super('updateServerWelcomeChannelInfo', params);
  }
}
